import style from "./FilterWrapper.module.css"; //
import React, { useState } from "react"; //
import { useTranslation } from "react-i18next"; //
import lesson_toOpenIcon from "../../../../base/assets/icons/lessons_toOpen.png";
import lesson_toCloseIcon from "../../../../base/assets/icons/lessons_toClose.png";

interface FilterWrapperPropsDI {
  fieldName: string;
  resetField: (fieldName: string) => void;
  mainText: string;
  children: JSX.Element;
}

const FilterWrapper: React.FC<FilterWrapperPropsDI> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const ariaLabel = t("Search-Filter-Option") + " " + props.mainText + " " + (isOpen ? t("Filter-Open") : t("Filter-Closed"));

  return (
    <div className={isOpen ? style.wrapperOpen : style.wrapperClosed}>
      <div className={style.domain__header} onClick={() => setIsOpen(!isOpen)}>
        <img
          src={!isOpen ? lesson_toOpenIcon : lesson_toCloseIcon}
          alt={t("Lesson-Filter-Field")}
          className={!isOpen ? style.closedFieldIcon : style.closedFieldIcon}
        />
        <p
          tabIndex={0}
          role="button"
          aria-label={ariaLabel}
          aria-live="polite"
          onKeyPress={(key) => {
            if (key.code === "Enter" || key.code === "Space") {
              setIsOpen(!isOpen);
            }
          }}
          className={style.domain__mainText}
        >
          {props.mainText}
        </p>
        {isOpen ? (
          <button
            aria-label={t("Lesson-search-reset")}
            onClick={() => {
              props.resetField(props.fieldName);
            }}
            className={style.filters__reset}
          >
            {t("Lesson-search-reset")}{" "}
          </button>
        ) : null}
      </div>
      {isOpen ? props.children : null}
    </div>
  );
};

export default FilterWrapper;
